"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "IThemeProviderProps", {
  enumerable: true,
  get: function get() {
    return _Theme.IThemeProviderProps;
  }
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _ThemeProvider = _interopRequireDefault(require("../ThemeProvider"));
var _Theme = require("../themes/Theme");
var _excluded = ["children", "themeMode", "direction"];
/**
 * @copyright
 * Copyright (c) 2022 Accretive Technology Group, Inc. All rights
 * reserved. For use only by Accretive Technology, its employees
 * and contractors. DO NOT DISTRIBUTE.
 */
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
/**
 * @deprecated Please use the updated ThemeProvider
 * ```tsx
 * import ThemeProvider from "icf-react-components/ThemeProvider";
 * ```
 * See more: https://icfreactcomponents.integ.icfsys.com/?path=/docs/intro-themeprovider--docs
 */
var WhitelabelThemeProvider = function WhitelabelThemeProvider(_ref) {
  var children = _ref.children,
    _ref$themeMode = _ref.themeMode,
    themeMode = _ref$themeMode === void 0 ? _Theme.ThemeMode.dark : _ref$themeMode,
    _ref$direction = _ref.direction,
    direction = _ref$direction === void 0 ? _Theme.Direction.ltr : _ref$direction,
    otherProps = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/_react.default.createElement(_ThemeProvider.default, _extends({
    platformId: _Theme.PlatformId.streamate,
    themeMode: themeMode
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore: we want to pass down every prop to support old implementations
    ,
    direction: direction
  }, otherProps), children);
};
WhitelabelThemeProvider.displayName = "WhitelabelThemeProvider";
var _default = exports.default = WhitelabelThemeProvider;